import debounce from 'react-utils/debounce';
import { compareAndClearInternalActiveEditor, getInternalActiveEditorAtom, setInternalActiveEditorAtom, subscribeToActiveEditorAtom } from './activeEditorAtom';
import initializeClearActiveEditorListener from './initializeClearActiveEditorListener';
import { getContentLangauge, getContextFromTinymceForCommand, getIsHighlightingText } from './utils';
export function initFocusOrSelectionHandlers(editor, focusHandler, focusEventNames, blurEventNames) {
  var _focusEventNames, _blurEventNames;
  focusEventNames = (_focusEventNames = focusEventNames) !== null && _focusEventNames !== void 0 ? _focusEventNames : 'focusin';
  blurEventNames = (_blurEventNames = blurEventNames) !== null && _blurEventNames !== void 0 ? _blurEventNames : 'focusout remove';
  const debouncedProcessQueue = debounce(() => {
    processActiveOrSelectionChange(focusHandler);
  }, 100);
  for (const focusEventName of focusEventNames.split(' ')) {
    editor.on(focusEventName, debouncedProcessQueue);
    editor.on(focusEventName, () => {
      setInternalActiveEditorAtom(editor);
    });
  }
  for (const blurEventName of blurEventNames.split(' ')) {
    editor.on(blurEventName, debouncedProcessQueue);
  }
  editor.on('NodeChange', debouncedProcessQueue);
  initializeClearActiveEditorListener();
  const unsubscribe = subscribeToActiveEditorAtom(debouncedProcessQueue);
  editor.on('remove', () => {
    unsubscribe();
    compareAndClearInternalActiveEditor(editor);
  });
}
function processActiveOrSelectionChange(focusHandler) {
  const activeEditor = getInternalActiveEditorAtom();
  const hasActiveEditor = !!activeEditor;
  if (!activeEditor) {
    focusHandler({
      hasFocus: false,
      hasSelection: false,
      // Appeasing the TS Gods
      editorContext: '',
      currentSelection: '',
      precedingText: '',
      followingText: '',
      contentLanguage: ''
    });
    return;
  }
  const isHighlightingText = getIsHighlightingText(activeEditor);
  const commandType = isHighlightingText ? 'highlight' : 'slash';
  const contentLanguage = getContentLangauge(activeEditor);
  const {
    currentSelection,
    hasSelection,
    editorContext,
    precedingText,
    followingText
  } = getContextFromTinymceForCommand(activeEditor, '', commandType);
  focusHandler({
    hasFocus: hasActiveEditor,
    hasSelection,
    currentSelection,
    editorContext,
    precedingText,
    followingText,
    contentLanguage
  });
}